module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageMetaDescription":"Elenco macchine"}}')
  delete Component.options._Ctor
}
